import React from "react";
import PropTypes from "prop-types";
import "react-phone-input-2/lib/style.css";
import Style from "./modal.module.scss";
import { accSetting, buttonName } from "../../locales/en";
import CommonModal from "./CommonModal";

const OnboardingAccountSettingsInfoModal = ({
  isOpen,
  toggle,
  connectedSoftName
}) => {
  const footerButtons = [
    {
      label: buttonName?.close,
      className: "btn btn-secondary",
      onClick: () => toggle(false)
    }
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={accSetting?.onboardingModal?.title}
      modalClassName={`${Style.xeroModal} ${Style.manualUploadModal} modal-lg modal-dialog-centered`}
      bodyClassName={`${Style.manualUploadContent} modal-content border-0`}
      footerButtons={footerButtons}
    >
      <div className={`${Style.manualUploadContent} modal-content border-0`}>
        <div className="inv-upload-template flex-sm-wrap-reverse">
          <div className={`${Style.manul_Invoice_Submit}`}>
            <p>
              {accSetting?.onboardingModal.p1} {`${connectedSoftName} `}
              {accSetting?.onboardingModal.p2}
              {` ${connectedSoftName}`} {accSetting?.onboardingModal.p3}
            </p>
            <ul>
              <li>
                {accSetting?.onboardingModal.li1} {`${connectedSoftName} `}
                {accSetting?.onboardingModal.li2}
              </li>
              <li>
                {accSetting?.onboardingModal.li3} {`${connectedSoftName} `}
                {accSetting?.onboardingModal.li4}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};
OnboardingAccountSettingsInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  connectedSoftName: PropTypes.any
};

export default OnboardingAccountSettingsInfoModal;
